(function ($) {
	'use_strict';
	$(function () {
		if (typeof gtag == 'undefined') {
			console.warn(
				'GA undefined, ensure google analytics is loaded. (You might also be logged in since GA isnt loaded for logged in users.)'
			);
			return;
		}

		$('.hpy_ga_ta_ev')
			.on('click', function () {
				send_event($(this));
			})
	});

	function send_event(_this) {
		var gaEventCat = _this.data('category');
		var gaEventAction = _this.data('action');
		var gaEventLabel = _this.data('label');
		gaEventLabel = gaEventLabel && gaEventLabel.length !== 0 ? gaEventLabel : '';

		send_event_raw(gaEventCat, gaEventAction, gaEventLabel);
	}

	function send_event_raw(category, action, label) {
		if (category && action && category.length !== 0 && action.length !== 0) {
			gtag('event', 'document_download', {
				event_category: category,
				event_action: action,
				event_label: label
			});
			console.log('Custom Event Tracked\nAction: ' + action + '\nCategory: ' + category + '\nLabel: ' + label);
		}
	}

})(jQuery);



